const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class CollectionBannerCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    window.addEventListener('resize', () => {
      if (this.carousel) {
        this.carousel.destroy()
        this.carousel = this.setupCarousel()
      }
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          spacing: 20,
          perView: 'auto',
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              spacing: 11,
              perView: 'auto',
            },
            rtl: false,
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('collection-banner-carousel')) {
  customElements.define('collection-banner-carousel', CollectionBannerCarousel)
}
